import { inject } from '@angular/core'
import { timer, throwError } from 'rxjs'
import { catchError, retry } from 'rxjs/operators'
import { ToastService } from '@common/services'
import { HttpErrorResponse, HttpInterceptorFn } from '@angular/common/http'

const RETRY_DELAYS_MS = [1000, 5000, 5000, 10000, 10000, 10000, 10000, 10000]

// Repetir sozinho só o que não muda estado. Uma gravação lenta chega a acontecer no servidor antes de o
// gateway devolver 503: a tentativa seguinte encontrava o registro já criado e voltava 400, então o
// usuário via erro com os dados salvos (foi o caso do salvar cotas de uma pesquisa de 415 itens).
const IDEMPOTENT_METHODS = ['GET', 'HEAD', 'OPTIONS']

const shouldRetry = (error: HttpErrorResponse, method: string) => {
	if (!IDEMPOTENT_METHODS.includes(method?.toUpperCase())) {
		return false
	}

	const message = `${error?.message || ''} ${error?.error?.message || ''}`.toLowerCase()

	return error?.status === 503 || error?.status === 0 || message.includes('sem conexão com o servidor')
}

const isOffline = (error: HttpErrorResponse) => error?.status === 0

export const RetryInterceptor: HttpInterceptorFn = (request, next) => {
	const toast = inject(ToastService)

	return next(request).pipe(
		retry({
			count: RETRY_DELAYS_MS.length,
			delay: (error: HttpErrorResponse, retryCount: number) => {
				if (!shouldRetry(error, request.method)) {
					throw error
				}

				return timer(RETRY_DELAYS_MS[retryCount - 1])
			}
		}),
		catchError((error: HttpErrorResponse) => {
			// O aviso de queda vale para qualquer método — deixar de repetir um POST não é motivo para
			// deixar de contar ao usuário que o servidor está fora.
			if (isOffline(error)) {
				toast.error('Sem conexão com o servidor.')
			}

			return throwError(() => error)
		})
	)
}
